import Jsona from 'jsona';
import { SET_HOSTS, type as hostType } from '@/store/host';
import { SET_TEAM_MEMBERS, type as teamMembersType } from '@/store/team-members';

export const type = 'calendar';

export const FETCH_SLOTS = 'FETCH_SLOTS';
export const FETCH_CACHED = 'FETCH_CACHED';

const SET_SLOTS = 'SET_SLOTS';
const SET_STALE_SLOTS = 'SET_STALE_SLOTS';
const SET_STALE_LOADED = 'SET_STALE_LOADED';
const INCREMENT_REQUEST_SEQUENCE = 'INCREMENT_REQUEST_SEQUENCE';
const SET_RESPONSE_SEQUENCE = 'SET_RESPONSE_SEQUENCE';
const SET_MAX_ALLOWED_BOOKING_DATE = 'SET_MAX_ALLOWED_BOOKING_DATE';

export const SLOTS = 'SLOTS';
export const STALE_SLOTS_LOADED = 'STALE_SLOTS_LOADED';
export const FRESH_SLOTS_LOADED = 'FRESH_SLOTS_LOADED';
const REQUEST_SEQUENCE_NUMBER = 'REQUEST_SEQUENCE_NUMBER';
export const MAX_ALLOWED_BOOKING_DATE = 'MAX_ALLOWED_BOOKING_DATE';

export const state = () => ({
  slots: {},
  staleSlots: {},
  requestSequenceNumber: 0, // keep sequence numbers to prevent out-of-order slot updates
  responseSequenceNumber: 0,
  stale: undefined,
  maxAllowedBookingDate: undefined // date object after which the backend won't return slots anymore
});

export const actions = {
  async [FETCH_SLOTS]({ getters, state, commit }, { params }) {
    try {
      commit(INCREMENT_REQUEST_SEQUENCE);
      const currentRequestCounter = getters[REQUEST_SEQUENCE_NUMBER];
      const response = await this.$axios.get(
        'api/v1/customer-booking-calendar', { params }
      );
      if (currentRequestCounter === state.requestSequenceNumber) {
        handleCalendarSuccessResponse(commit, SET_SLOTS, response);
        commit(SET_STALE_LOADED, { stale: false });
        commit(SET_RESPONSE_SEQUENCE, currentRequestCounter);
      }
    } catch (e) {
      handleCalendarError(commit, e);
    }
  },

  async [FETCH_CACHED]({ getters, state, commit }, { params }) {
    commit(SET_STALE_LOADED, { stale: false });
    try {
      const response = await this.$axios.get(
        'api/v1/customer-booking-calendar/cached', { params }
      );
      if (response.status === 200) {
        // the endpoint returns different status codes for cache hit (200), miss or ignored.
        handleCalendarSuccessResponse(commit, SET_STALE_SLOTS, response);
        commit(SET_STALE_LOADED, { stale: true });
      } else {
        commit(SET_STALE_LOADED, { stale: false });
      }
    } catch (e) {
      commit(SET_STALE_LOADED, { stale: false });
    }
  }
};

export const mutations = {
  [SET_SLOTS](state, { slots }) {
    state.slots = slots;
  },
  [SET_STALE_SLOTS](state, { slots }) {
    state.staleSlots = slots;
  },
  [SET_STALE_LOADED](state, { stale }) {
    state.stale = stale;
  },
  [INCREMENT_REQUEST_SEQUENCE](state) {
    state.requestSequenceNumber += 1;
  },
  [SET_RESPONSE_SEQUENCE](state, responseSequenceNumber) {
    state.responseSequenceNumber = responseSequenceNumber;
  },
  [SET_MAX_ALLOWED_BOOKING_DATE](state, { maxAllowedBookingDate }) {
    state.maxAllowedBookingDate = maxAllowedBookingDate;
  }
};

export const getters = {
  [SLOTS](state) {
    return state.stale === true ? state.staleSlots : state.slots;
  },
  [STALE_SLOTS_LOADED](state) {
    return state.stale;
  },
  [FRESH_SLOTS_LOADED](state) {
    return state.requestSequenceNumber > 0 && state.requestSequenceNumber === state.responseSequenceNumber;
  },
  [REQUEST_SEQUENCE_NUMBER](state) {
    return state.requestSequenceNumber;
  },
  [MAX_ALLOWED_BOOKING_DATE](state) {
    return state.maxAllowedBookingDate;
  }
};

function handleCalendarSuccessResponse(commit, slotMutation, response) {
  const {
    days, hostUsers, teamMemberUsers, maxAllowedBookingDate
  } = new Jsona().deserialize(response.data);

  commit(slotMutation, { slots: days });
  commit(SET_MAX_ALLOWED_BOOKING_DATE, { maxAllowedBookingDate });
  commit(`${hostType}/${SET_HOSTS}`, hostUsers, { root: true });
  commit(`${teamMembersType}/${SET_TEAM_MEMBERS}`, teamMemberUsers, { root: true });
}

function handleCalendarError(commit, error) {
  commit(`${hostType}/${SET_HOSTS}`, [], { root: true });
  commit(SET_STALE_SLOTS, [], { root: true });
  commit(SET_STALE_LOADED, { stale: false });
  throw error;
}
